import { useCallback, useRef } from 'react';
import type { Entity } from '../types';
import type { GoodsData } from '@banhala/ui-kit';
import type { FlatListProps } from 'react-native';
import { bridge } from '../../../../../utils';

export const useLogDisplayGoods = () => {
  const goodsItemLoggedList = useRef<Array<number>>([]);

  const logDisplayGoods = useCallback<
    NonNullable<FlatListProps<GoodsData & Entity>['onViewableItemsChanged']>
  >(({ viewableItems }) => {
    viewableItems.forEach(({ index, isViewable, item }) => {
      if (index === null || !isViewable) {
        return;
      }
      if (goodsItemLoggedList.current.includes(index)) {
        return;
      }
      goodsItemLoggedList.current.push(index);

      bridge.logAnalyticsEvent({
        channel: ['firebase', 'amplitude', 'ablylog', 'facebook'],
        name: 'DISPLAY_GOODS',
        analytics: item.logging.analytics,
        ably_only_log: item.logging.ably_only_log,
      });
    });
  }, []);

  return { logDisplayGoods };
};
